export function loadPage(pageUri, options, event) {
    const routePath =
        '/' + (pageUri.startsWith('#') ? pageUri.substr(1) : pageUri);
    window.newVueApp.$router.push(routePath).catch((error) => {
        if (error.type == 16) {
            //Duplicated
            window.newVueApp.$router.go();
        }
    });
}
